import { AccountIcon, getAccountIconVariant } from "@kyan/ui";
import { Address } from "viem";

import { useAccountName } from "#/hooks/useAccountName";

interface InternalAccountProps {
  address: Address;
  index: number;
}

export const InternalAccount: React.FC<InternalAccountProps> = ({
  index,
  address,
}) => {
  const { accountName } = useAccountName(address, index);

  return (
    <div className="flex items-center gap-2 text-xs">
      <AccountIcon variant={getAccountIconVariant(index)} />
      {accountName}
    </div>
  );
};
